import React, { useEffect } from "react";

import './Page50x.scss';

const Page50x: React.FC = () => {

    useEffect(() => {
        document.getElementsByTagName('html')[0].classList.add('error-50x__html');
        document.getElementsByTagName('body')[0].classList.add('error-50x__body');
    });

    return (
        <div className="error-50x">
            <h1>An error occurred.</h1>
            <p>Sorry, the page you are looking for is currently unavailable.<br />
                Please try again later.</p>
            <p>If you are the system administrator of this resource then you should check
                the error log for details.</p>
            <p><em>Faithfully yours, nginx.</em></p>
        </div>
    );
}

export default Page50x;